module.exports = __webpack_public_path__ + "media/components/app-store/static/sfc-featured-5fc5b63437e2262600f4d92b1d235ec7.jpg";